module.exports = __webpack_public_path__ + "media/bootstrap-icons/app-dd5ed185.svg";